import { useState, useEffect } from "react";
import { getAddressByEntity } from "@/services/addresses";
export default function useAddresses({ dealerId, searchText, disabled = false, configPerm }) {
    const [addresses, setAddresses] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        const fetchAddresses = async () => {
            if (disabled) {
                return;
            }
            if (!configPerm["CoreService.Addresses"]) {
                return;
            }
            setIsLoading(true);
            try {
                const res = await getAddressByEntity(dealerId, searchText);
                setAddresses(res?.items || []);
            }
            catch (err) {
                console.error(err);
            }
            finally {
                setIsLoading(false);
            }
        };
        fetchAddresses();
    }, [dealerId, searchText, disabled, configPerm]);
    return {
        addresses,
        isLoading,
    };
}
